export const LogLevel = {
  ALERT: 'alert',
  LOG: 'log',
  STATUS: 'status',
} as const;

export type LogLevel = Union<typeof LogLevel>;
